import axios from "axios";
import config from "./config";
import type { ContractSigningPayload, SigningBillingInfo } from "../components/bessOnboarding/ContractPreviewModal";

export interface BessSignTokenContractData {
  contract_id: number;
  installation_id: string;
  pdf_url: string;
  site_name: string;
  company_name: string;
  company_id: number;
  signer_name: string;
  start_date: string;
  end_date: string | null;
  profit_share: string;
  monthly_fee: string;
  steering_fee_performance_pct: string;
  inverter_power: number;
  opportunity_cost: number;
  controller: string;
  partner_id: number;
  partner_name?: string;
  injection_installation_id: string;
  offtake_installation_id: string | null;
  billing_info: SigningBillingInfo;
  canSign?: boolean;
  signBlockedReason?: "INJECTION_UNSIGNED" | "OFFTAKE_UNSIGNED" | null;
}

export async function fetchBessContractByToken(token: string): Promise<BessSignTokenContractData> {
  const { data } = await axios.get<BessSignTokenContractData>(
    `${config.API_SERVICES}/api/v1/sdp/bess/sign-token/${token}`
  );
  return data;
}

export async function signBessContractByToken(
  token: string,
  payload: ContractSigningPayload & { contract_id: number }
): Promise<void> {
  await axios.post(
    `${config.API_SERVICES}/api/v1/sdp/bess/sign-token/${token}`,
    payload
  );
}
